import { render, staticRenderFns } from "./ArrobaMedellinVerticalCardEvents.html?vue&type=template&id=33e66ec7&scoped=true&"
import script from "./ArrobaMedellinVerticalCardEvents.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinVerticalCardEvents.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinVerticalCardEvents.scss?vue&type=style&index=0&id=33e66ec7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e66ec7",
  null
  
)

export default component.exports